import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Container, Grid, List, ListItem, TextField, Typography } from '@mui/material';
import { getUserFromStorage } from '../../utils/functionHelper';
import PageHeader from '../../components/pageHeader/PageHeader';
import { AppPageNameRoutes, AppPageNameRouteType } from '../../routes/paths';
import { UserDto } from '../../api';
import { UserAvatar } from '../../components/common';
import { requestPasswordChange } from '../../utils/passwordChange';
import { setSnackbar, SnackbarStates } from '../../redux/snackbar';
import { setLoadingStatus } from '../../redux/loading';
import { useDispatch } from 'react-redux';

const breadcrumbs: AppPageNameRouteType[] = [AppPageNameRoutes.PROFILE];

export default function Profile() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const user: UserDto | null = getUserFromStorage();

  if (!user) {
    throw Error('Enable to locate user in storage');
  }

  const handlePasswordChangeRequest = async () => {
    if (!user.email) {
      return;
    }
    try {
      dispatch(setLoadingStatus(true));
      await requestPasswordChange(user.email, 'CHANGE_REQUEST');
      dispatch(setSnackbar(true, SnackbarStates.SUCCESS, t('pages.loginPage.forgottenPassword.requestSentMessage')));
    } catch (error: unknown) {
      let reason = '';
      if (error instanceof Error) {
        reason = error.message;
      }
      dispatch(setSnackbar(true, SnackbarStates.ERROR, t('userError.genericRequestFailed', { reason })));
      return;
    } finally {
      dispatch(setLoadingStatus(false));
    }
  };

  return (
    <Container className='page'>
      <Grid
        container
        direction={'row'}
        justifyContent={'space-between'}
        alignItems='center'
      >
        <Grid
          item
          className='text-left'
        >
          <PageHeader
            headline={'profile'}
            breadcrumbs={breadcrumbs}
            headlineParams={{ userName: user.fullName }}
          />
        </Grid>
        <Grid item>
          <UserAvatar user={user} />
        </Grid>
      </Grid>
      <Grid className='filter__holder'>
        <Box>
          <Typography variant={'h6'}>{t('pages.profile.basicInfo')}</Typography>
          <Grid container>
            <Grid item>
              <TextField
                id='total-bonuses-crn'
                label={t('pages.profile.name')}
                type='text'
                value={user.name}
                disabled
                variant={'outlined'}
              />
            </Grid>
            <Grid item>
              <TextField
                id='total-bonuses-crn'
                label={t('pages.profile.surname')}
                type='text'
                value={user.surname}
                disabled
                variant={'outlined'}
              />
            </Grid>
            <Grid item>
              <TextField
                id='total-bonuses-crn'
                label={t('pages.profile.userName')}
                type='text'
                value={user.userName}
                disabled
                variant={'outlined'}
              />
            </Grid>
            <Grid
              item
              alignSelf='center'
              marginLeft='auto'
            >
              <Button
                disabled={!user.email}
                onClick={handlePasswordChangeRequest}
                variant='contained'
              >
                {t('pages.profile.actions.changePassword')}
              </Button>
            </Grid>
          </Grid>
        </Box>
        <Box>
          <Typography variant={'h6'}>{t('pages.profile.assignedRoles')}</Typography>
          <List>
            {user.roles.map((role) => (
              <ListItem>{t('roles.values.' + role)}</ListItem>
            ))}
          </List>
        </Box>
      </Grid>
    </Container>
  );
}
